export enum SortingStatus {
    ASC,
    DESC,
    NONE,
}
